import { I18N } from 'aurelia-i18n';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';

export class ToLocaleDateTimeFromNowBaseValueConverter {
    toView(value) {
        if (ObjectHelper.IsNotNullAndUndefined(value)) {
            let i18n = new I18N();
            let now = moment(moment.now());
            let start = moment(value);
            let valueTimeText: string = moment(value).format('LT');
            if (now.diff(start, 'days') > 0) {
                return moment(value).format('l LT');
            } else {
                if (now.diff(start, 'hour') > 0) {
                    if (now.diff(start, 'hour') == 1) {
                        return now.diff(start, 'hour') + " " + i18n.tr("ToLocaleDateTimeFromNowValueConverter.OneHours") + ' ' + valueTimeText;
                    } else {
                        if ((now.diff(start, 'hour') > 1) && (now.diff(start, 'hour') <= 4)) {
                            return now.diff(start, 'hour') + " " + i18n.tr("ToLocaleDateTimeFromNowValueConverter.OtherHoursToTen") + ' ' + valueTimeText;
                        } else {
                            return now.diff(start, 'hour') + " " + i18n.tr("ToLocaleDateTimeFromNowValueConverter.Hours") + ' ' + valueTimeText;
                        }
                    }
                }
                else {
                    if (now.diff(start, 'minutes') > 0) {
                        if (now.diff(start, 'minutes') == 1) {
                            return now.diff(start, 'minutes') + " " + i18n.tr("ToLocaleDateTimeFromNowValueConverter.OneMinutes") + ' ' + valueTimeText;
                        } else {
                            if ((now.diff(start, 'minutes') > 1) && (now.diff(start, 'minutes') <= 4)) {
                                return now.diff(start, 'minutes') + " " + i18n.tr("ToLocaleDateTimeFromNowValueConverter.OtherMinutesToTen") + ' ' + valueTimeText;
                            } else {
                                return now.diff(start, 'minutes') + " " + i18n.tr("ToLocaleDateTimeFromNowValueConverter.Minutes") + ' ' + valueTimeText;
                            }
                        }
                    }
                    else {
                        if (now.diff(start, 'second') > 30) {
                            return now.diff(start, 'second') + " " + i18n.tr("ToLocaleDateTimeFromNowValueConverter.Seconds") + ' ' + valueTimeText;
                        }
                        else {
                            return i18n.tr("ToLocaleDateTimeFromNowValueConverter.JustNow");
                        }
                    }
                }
            }
        }
        return value;
    }
}